import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkClosureComponent } from './work-closure.component';

const routes: Routes = [
  {
    path: '',
    component: WorkClosureComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClosingWorkRoutingModule { }
